var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoopAlt4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.596,
    height: 10.947,
    viewBox: "0 0 14.596 10.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d9d9d9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.771,10.386a.914.914,0,0,1-.912.912H3.645V9.473L0,12.21l3.645,2.737V13.122h8.214A2.741,2.741,0,0,0,14.6,10.386ZM2.737,7.649h8.21V9.473L14.6,6.737,10.947,4V5.824H2.737A2.739,2.739,0,0,0,0,8.561H1.824A.914.914,0,0,1,2.737,7.649Z",
    transform: "translate(0 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopAlt4);
export default __webpack_public_path__ + "static/media/loop-alt4.59a9e346.svg";
export { ForwardRef as ReactComponent };